import React, { useEffect, useState } from "react";
import moment from "moment";
import { Badge, Card, CardBody, Input } from "reactstrap";
import { UpdateBlogPost } from "services/V2_APIs/blog.service";
import Spinner from "components/spinner";
import Switch from "react-switch";
const BlogsDetailsPage = ({
  activeBlog,
  handleActiveEdit,
  handleActiveDelete,
}) => {
  const [loading, setLoading] = useState(false);
  const [blogData, setBlogData] = useState(activeBlog);

  useEffect(() => {
    setBlogData(activeBlog);
  }, [activeBlog]);
  const handleToggleCommentVisibility = index => {
    const updatedBlog = {
      ...blogData,
      comments: [...(blogData.comments || [])],
    };
    updatedBlog.comments[index] = {
      ...updatedBlog.comments[index],
      isActive: !(
        updatedBlog.comments[index].isActive === true ||
        updatedBlog.comments[index].isActive === "true"
      ),
    };

    setBlogData(updatedBlog);
    setLoading(true);

    UpdateBlogPost(blogData?._id, updatedBlog)
      .then(res => {
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
        setBlogData(blogData);
      });
  };

  const handleToggleBlogActive = () => {
    const updatedBlog = {
      ...blogData,
      isActive: !(blogData?.isActive === true || blogData?.isActive === "true"),
    };

    setBlogData(updatedBlog);

    setLoading(true);
    UpdateBlogPost(updatedBlog._id, updatedBlog)
      .then(res => {
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
        setBlogData(blogData);
      });
  };

  return (
    <>
      <Spinner loading={loading} />
      {!blogData?._id ? (
        <div>
          <Card className="p-3 pt-0 empty_order">
            <CardBody className="border-3">
              <div className="text-center">
                <i className="mdi mdi-arrow-left-circle" id="nullCatList"></i>
              </div>
              <p className="text-center">Please Select Order</p>
            </CardBody>
          </Card>
        </div>
      ) : (
        <div style={{ padding: "2rem", backgroundColor: "" }}>
          <div style={headerCardStyle()}>
            <h4>{blogData.title}</h4>
            <p className="mb-1">
              <strong>By:</strong> {blogData?.userName}
            </p>

            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
              <p className="mb-0">
                <strong>Created On:</strong>{" "}
                {moment(blogData.createdAt).format("MMMM Do YYYY, h:mm A")}
              </p>
              <p className="mb-0">
                <strong>Published On:</strong>{" "}
                {moment(blogData.publishedDate).format("MMMM Do YYYY")}
              </p>
              </div>

              <div className="d-flex justify-content-end align-items-center">
                <Badge
                  className="font-size-12 badge-soft-info py-1 px-3 me-2"
                  color={"bg-info"}
                  role="button"
                  pill
                  onClick={() => {
                    handleActiveEdit(blogData);
                  }}
                >
                  <i className="mdi mdi-pencil font-size-14" /> Edit
                </Badge>
                <Badge
                  className="font-size-12 badge-soft-danger py-1 px-3 me-2"
                  color={"bg-danger"}
                  role="button"
                  pill
                  onClick={() => {
                    handleActiveDelete(blogData);
                  }}
                >
                  <i className="mdi mdi-delete font-size-14" />
                </Badge>
                <div className="d-flex align-items-center ms-2">
                  <span className="me-2">Is Active</span>
                  <Switch
                    onChange={handleToggleBlogActive}
                    checked={
                      blogData?.isActive === true ||
                      blogData?.isActive === "true"
                    }
                    onColor="#86d3ff"
                    onHandleColor="#2693e6"
                    handleDiameter={25}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 2px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={15}
                    width={40}
                    className="react-switch"
                    id="blog_is_active_switch"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Banners */}
          <h2 style={sectionTitle}>Banners</h2>
          <div style={cardStyle}>
            <div style={{ marginBottom: "1rem" }}>
              <p>
                <strong>Web Banner:</strong>
              </p>
              <img
                src={blogData.webBanner}
                alt="Web Banner"
                style={bannerStyle}
              />
            </div>
            <div>
              <p>
                <strong>Mobile Banner:</strong>
              </p>
              <img
                src={blogData.mobileBanner}
                alt="Mobile Banner"
                style={bannerStyle}
              />
            </div>
          </div>

          {/* Short Description */}
          <h2 style={sectionTitle}>Short Description</h2>
          <div style={cardStyle}>
            <div
              dangerouslySetInnerHTML={{ __html: blogData.shortDescription }}
            />
          </div>
          <h2 style={sectionTitle}>Long Description</h2>
          {/* Main Content Sections */}
          <div style={cardStyle}>
            {blogData.content?.map(section => (
              <div key={section._id}>
                <h2 style={sectionTitle} dangerouslySetInnerHTML={{ __html: section.title }}/>
                <div
                  dangerouslySetInnerHTML={{ __html: section.description }}
                />
              </div>
            ))}
          </div>

          {/* Right Side Web Content */}
          <h2 style={sectionTitle}>Right Side Content</h2>
          {blogData.rightSideWebContent?.length > 0 && (
            <div
              style={{
                ...cardStyle,
                backgroundColor: blogData?.backgroundColorCode,
              }}
            >
              {blogData.rightSideWebContent.map(item => (
                <div
                  key={item._id}
                  style={{
                    marginBottom: "1rem",
                  }}
                >
                  <h3 dangerouslySetInnerHTML={{ __html: item.heading }}/>
                  <p dangerouslySetInnerHTML={{ __html: item.content }} />
                </div>
              ))}
            </div>
          )}

          {/* Comments */}

          {blogData.comments.map((comment, index) => {
            console.log(comment, "comment");
            return (
              <div
                key={comment._id}
                style={commentBoxStyle}
                className="d-flex align-items-center justify-content-between flex-wrap"
              >
                <div>
                  <p className="mb-1">
                    <strong>
                      {comment.userId === blogData.userId
                        ? blogData.userName
                        : "User"}
                    </strong>
                  </p>
                  <p className="mb-1">{comment.commentText}</p>
                  <p
                    style={{ fontSize: "0.85rem", color: "#666" }}
                    className="mb-1"
                  >
                    👍 {comment.commentLikes} likes
                  </p>
                </div>

                <div className="d-flex align-items-center">
                  <span className="me-2">Is Visibile</span>
                  <Switch
                    onChange={() => handleToggleCommentVisibility(index)}
                    checked={
                      comment.isActive === true || comment.isActive === "true"
                    }
                    onColor="#86d3ff"
                    onHandleColor="#2693e6"
                    handleDiameter={25}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 2px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={15}
                    width={40}
                    className="react-switch"
                    id="is_active_switch"
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default BlogsDetailsPage;

// === Styles ===
const cardStyle = {
  backgroundColor: "#fff",
  padding: "1rem",
  borderRadius: "12px",
  marginBottom: "1.5rem",
  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
};

const headerCardStyle = bg => ({
  backgroundColor: "#fff",
  padding: "1rem",
  borderRadius: "12px",
  marginBottom: "1.5rem",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
});

const sectionTitle = {
  fontSize: "1rem",
  fontWeight: "600",
  marginBottom: "1rem",
};

const bannerStyle = {
  width: "100%",
  borderRadius: "8px",
  objectFit: "cover",
  marginTop: "0.5rem",
};

const commentBoxStyle = {
  backgroundColor: "#f2f2f2",
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #ddd",
  marginBottom: "5px",
};
